import { render, staticRenderFns } from "./settingsidebar.vue?vue&type=template&id=8dce8b72"
import script from "./settingsidebar.vue?vue&type=script&lang=js"
export * from "./settingsidebar.vue?vue&type=script&lang=js"
import style0 from "./settingsidebar.vue?vue&type=style&index=0&id=8dce8b72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports